import type { ReactNode } from 'react'

/**
 * An invitation to act, not a mood piece: a signage line, one plain sentence,
 * and the action itself. Left-aligned because it stands in for a list of board
 * rows and should sit on the same reading edge they do.
 *
 * `icon` is honoured for callers that pass one, but kept small and faint —
 * nothing here should read as illustration.
 */
export function EmptyState({
  title,
  description,
  icon,
  action,
}: {
  title: string
  description?: ReactNode
  icon?: ReactNode
  action?: ReactNode
}) {
  return (
    <div className="rounded border border-dashed border-line px-4 py-8 sm:px-5">
      {icon ? <div className="mb-2 text-faint [&_svg]:size-5">{icon}</div> : null}
      <p className="signage text-[11px] text-ink">{title}</p>
      {description ? <p className="mt-2 max-w-prose text-sm text-muted">{description}</p> : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  )
}
